import React, { useState} from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import IMTContractEdit from './imtContractEdit';
import IMTContractAdd from './imtContractAdd';
import ChevronDownIcon from '../Assets/icons/chevron.svg';
import {  ChevronWrapper,  EditLabel } from './StyledComponents';
import useimtContract from '../Hooks/IMTcontractHooks/useImtContract';
import adminBg from '../Assets/bg/adminbg.jpg';
import Loader from '../Components/Loader';

const ImtContract = ({ setShowimtContract, isSidebarExpanded, darkMode, onBack, onSelect }) => {
  const navigate = useNavigate();
  const [selectedItem, setSelectedItem] = useState(null);
  const [showEditPanel, setShowEditPanel] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const { data, loading, error } = useimtContract();


  const handleEditData = (item) => {
    setSelectedItem(item);
    setShowEditPanel(true);
  };

  const closeEditPanel = () => {
    setShowEditPanel(false);
    setSelectedItem(null);
  };

  const handleBackClick = () => {
    const pendingCisReturn = localStorage.getItem('cisMachineriesReturn');
    if (pendingCisReturn && typeof onSelect === 'function') {
      onSelect('CIS');
      return;
    }

    if (typeof onBack === 'function') {
      onBack();
      return;
    }

    if (typeof setShowimtContract === 'function') {
      setShowimtContract();
      return;
    }

    navigate(-1);
  };

  const filteredData = data.filter(item =>
    (item.iaName?.toLowerCase() || '').includes(searchQuery.toLowerCase()) ||
    (item.municipality?.toLowerCase() || '').includes(searchQuery.toLowerCase()) ||
    (item.iaPresident?.toLowerCase() || '').includes(searchQuery.toLowerCase())
  );
  
  if (loading) {
       return (
         <div style={{
           display: 'flex',
           justifyContent: 'center',
           alignItems: 'center',
           height: '100vh',
           backgroundColor: darkMode ? 'black' : 'white',
         }}>
           <Loader />
         </div>
       );
    }   

  if (error) {
    return <div>Error: {error.message}</div>; 
  }

  return (
    <SlidingPanel darkMode={darkMode}show={true} isSidebarExpanded={isSidebarExpanded}>
    <BackButton type="button" onClick={handleBackClick}>Back</BackButton>
    <Container darkMode={darkMode} isSidebarExpanded={isSidebarExpanded}>
    <Header darkMode={darkMode}>
    <Heading darkMode={darkMode}>IA IMT Contract Profile</Heading>
        </Header>

        <SearchContainer>
        <SearchInput
          type="text"
          placeholder="Search Province..."
          value={searchQuery}
           onChange={(e) => setSearchQuery(e.target.value)}
        />
        </SearchContainer>

        <TableWrapper>
        <Table darkMode={darkMode}>
            <thead>
              <tr>
                <TableHeader  darkMode={darkMode}>No</TableHeader>
                <TableHeader  darkMode={darkMode}>REGION</TableHeader>
                <TableHeader  darkMode={darkMode}>IMO</TableHeader>
                <TableHeader  darkMode={darkMode}>PROVINCE</TableHeader>
                <TableHeader  darkMode={darkMode}>NAME OF PROJECT/SYSTEM</TableHeader>     
                <TableHeader  darkMode={darkMode}>MOA SIGNED</TableHeader>
                <TableHeader  darkMode={darkMode}>DATE CONSTRUCTION STARTED</TableHeader>
                <TableHeader  darkMode={darkMode}>DATE PROJECT COMPLETED</TableHeader>
                <TableHeader  darkMode={darkMode}>DATE TURNED OVER</TableHeader>
                <TableHeader  darkMode={darkMode}>DATE PCR SUBMITTED</TableHeader>
                <TableHeader  darkMode={darkMode}>DATE O&M MANUAL SUBMITTED</TableHeader>
                <TableHeader  darkMode={darkMode}>DATE MODIFIED  IMT CONTRACT SIGNED</TableHeader>
                <TableHeader  darkMode={darkMode}>CONTRACT AREA</TableHeader>

                
           

                <TableHeader darkMode={darkMode} colSpan="7" style={{ textAlign: 'center' }}>
                CANAL INVENTORY
                </TableHeader>

            
              </tr>

              <tr>
              <TableHeaderS  colSpan="1" darkMode={darkMode}></TableHeaderS>
              <TableHeaderS  colSpan="12" darkMode={darkMode}></TableHeaderS>
              <TableHeaderS darkMode={darkMode}>TYPE OF CANAL</TableHeaderS>
              <TableHeaderS darkMode={darkMode}>STATION</TableHeaderS>
            <TableHeaderS darkMode={darkMode}>LINED (Km)</TableHeaderS>
            <TableHeaderS darkMode={darkMode}>UNLINED (Km)</TableHeaderS>
            <TableHeaderS darkMode={darkMode}>PIPES(km)</TableHeaderS>

           </tr>
            </thead>
            <tbody>
            {filteredData.map((item, index) => (
                <TableRow key={item.id} darkMode={darkMode}>
                  <TableData darkMode={darkMode}>
                  {index + 1}
                    <ChevronWrapper>
             <StyledChevronIcon src={ChevronDownIcon} alt="Chevron" />
             <EditLabel onClick={() => handleEditData(item)}> Edit</EditLabel>
            </ChevronWrapper>
                  </TableData>
                  <TableData darkMode={darkMode}>{item.region}</TableData>
                  <TableData darkMode={darkMode}className="station-imo">{item.imo}</TableData>
                  <TableData darkMode={darkMode}>{item.province}</TableData>
                  <TableData darkMode={darkMode}>{item.projectName}</TableData>
                  <TableData darkMode={darkMode}>{item.moaSigned}</TableData>
                  <TableData darkMode={darkMode}>{item.constructionStarted}</TableData>
                  <TableData darkMode={darkMode}>{item.projectCompleted}</TableData>
                  <TableData darkMode={darkMode}>{item.turnOver}</TableData>
                  <TableData darkMode={darkMode}>{item.pcr_submitted}</TableData>
                  <TableData darkMode={darkMode}>{item.manualSubmitted}</TableData>
                  <TableData darkMode={darkMode}>{item.imt_contractSigned}</TableData>
                  <TableData darkMode={darkMode}>{item.contractArea}</TableData>  
                  <TableData darkMode={darkMode}className="station-canal">{item.canalType}</TableData>
                  <TableData darkMode={darkMode} className="station-column">
                            {item.station}
                  </TableData>

                  <TableData darkMode={darkMode}>{item.lined}</TableData>
                  <TableData darkMode={darkMode}>{item.unlined}</TableData>
                  <TableData darkMode={darkMode}>{item.pipes}</TableData>
                  
                </TableRow>
              ))}
            </tbody>
          </Table>
        </TableWrapper>

        {showEditPanel && <IMTContractEdit selectedItem={selectedItem} closeEditPanel={closeEditPanel} />}
      </Container>

      <RightPanel  darkMode={darkMode} >
      <IMTContractAdd darkMode={darkMode}/>
      </RightPanel>
    </SlidingPanel>
  );
};

export default ImtContract;

const Container = styled.div`
  background-color: ${({ darkMode }) => (darkMode ? 'transparent' : '#f2f2f2')};
  background-image: ${({ darkMode }) => (darkMode ? `url(${adminBg})` : 'none')};
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  color: ${({ darkMode }) => (darkMode ? ' #757272' : '#333')};
  display: 'flex',
  padding: 10px;
  width: ${({ isSidebarExpanded }) => (isSidebarExpanded ? 'calc(100% - 110px)' : '55%')};
  min-height: 100vh;
  overflow-y: auto;
  margin-left: ${({ isSidebarExpanded }) => (isSidebarExpanded ? '110px' : '10px')};
  margin-top: 30px;
  box-shadow: -4px 0 10px rgba(0, 0, 0, 0.2);
  transition: margin-left 0.3s ease, width 0.3s ease;
`;

const SlidingPanel = styled.div`
  position: fixed;
  top: 0px;
  right: ${({ isSidebarExpanded }) => (isSidebarExpanded ? '0%' : '0')};
  width: 97%;
  height: 100%;
  background-color: ${({ darkMode }) => (darkMode ? 'transparent' : '#ccc')};
  background-image: ${({ darkMode }) => (darkMode ? `url(${adminBg})` : 'none')};
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  box-shadow: -4px 0 10px rgba(0, 0, 0, 0.2);
  transform: translateX(100%);
  transition: transform 0.5s ease, right 0.3s ease-in-out, width 0.3s ease-in-out;
  z-index: 2;
  padding: 20px;
  box-sizing: border-box;

  ${({ show }) => show && `transform: translateX(0);`}
`;

const Header = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-left: 0px;
  margin-bottom: 5px;
  margin-top: 5px;
`;

const Heading = styled.h2`
  font-size: 20px;
 color: ${({ darkMode }) => (darkMode ? '#fff' : '#333')};
  font-weight: bold;
  text-transform: uppercase;
  font-family: 'Poppins', sans-serif;
  margin-bottom: 0px;
`;


const StyledChevronIcon = styled.img`
  margin-top: -25px;  
  margin-left: 5px;  
   width: 14px; 
  height: 14px;   // Add margin to the left
`;


const TableWrapper = styled.div`
  width: 100%;
 height: 500px;
 overflow: auto; 
 margin-top: 10px;
  position: relative;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  min-width: 1500px;
  background-color: ${({ darkMode }) => (darkMode ?  'rgb(42, 48, 42)' : '#fff')};
  color: ${({ darkMode }) => (darkMode ? '#fff' : '#333')};
  
`;

const TableHeaderS = styled.th`
  background-color: ${({ darkMode }) => (darkMode ? 'rgb(36, 110, 45)' : '#f2f2f2')};
 padding: 0 10px;
  top: 39px;
  position: sticky;
  z-index: 1;
  text-align: center;
  border-left: 1px solid #ddd; /* Keep left border */
  border-right: 1px solid #ddd; /* Keep right border */
  border-top: 1px solid #ddd; 
  border-bottom: 2px solid #ddd;
  font-size: 12px;
  color: ${({ darkMode }) => (darkMode ? '#fff' : '#333')};

   &:first-child {
    position: sticky;
    left: 0;
    z-index: 3; /* Ensure it's above the other headers */
    background-color: ${({ darkMode }) => (darkMode ? 'rgb(25, 88, 32)' : '#f2f2f2')}; /* Ensure it matches the background */
  }

   &[colspan="2"] {
    text-align: center;
    font-weight: bold;
  }
`;

const TableHeader = styled.th`
  background-color: ${({ darkMode }) => (darkMode ? '#f2f2f2' : 'rgb(37, 112, 46)')};
  padding: 0 20px;
  height: 10px;
  top: 0px;
  position: sticky;
  z-index: 2;
  text-align: center;  /* Center text horizontally */
  vertical-align: middle; 
  border-left: 1px solid #ddd; /* Keep left border */
  border-right: 1px solid #ddd; /* Keep right border */
  border-top: 1px solid #ddd; /* Keep top border */
  border-bottom: none;
  font-size: 14px;
  color: ${({ darkMode }) => (darkMode ? '#333' : '#fff')};
  margin-top: 10px;

   &:first-child {
    position: sticky;
    left: 0;
    z-index: 3; /* Ensure it's above the other headers */
    background-color: ${({ darkMode }) => (darkMode ? '#f2f2f2' : 'rgb(37, 112, 46)')}; 
  }

   &[colspan="2"] {
    text-align: center;
    font-weight: bold;
  }
`;

const TableData = styled.td`
  padding: 5 5px;
  font-size: 12px;
  text-align: center;
  border: 1px solid #ddd;
  color: ${({ darkMode }) => (darkMode ? '#f2f2f2' : '#333')};
 
  transition: background-color 0.3s ease, color 0.3s ease;

  &:first-child {
    position: sticky;
    left: 0;
    background-color: ${({ darkMode }) => (darkMode ? 'rgb(37, 112, 46)2' : '#f2f2f2')}; 
    
   };
    z-index: 1;
  }
 
   &.station-column {
    min-width: 180px;
    max-width: 250px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &.station-imo {
    min-width: 150px;
    max-width: 250px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

   &.station-canal {
    min-width: 150px;
    max-width: 250px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

const TableRow = styled.tr`
 background-color: ${({ darkMode }) => (darkMode ? 'rgb(13, 99, 17)' : '#f9f9f9')};

   &:hover {
    background-color: ${({ darkMode }) => (darkMode ? 'rgb(37, 112, 46)' : 'rgb(37, 112, 46)')};
    background-size: cover;
    color: ${({ darkMode }) => (darkMode ? '#f2f2f2' : '#fff')}; // Ensure the text color changes too
    z-index: 10;  // Ensure it overlaps correctly during hover (if needed)
  }

  /* Hover effect on cells inside the row */
  &:hover td {
    background-image: ${({ darkMode }) => (darkMode ? `url(${adminBg})` : 'none')};
    background-size: cover;
    color: ${({ darkMode }) => (darkMode ? '#fff' : '#fff')};  // Text color change on hover
  }
`;

const RightPanel = styled.div`
  position: fixed;
  padding-top: 10px;
  margin-top: 14px;
  top: 0;
  right: 0;
  width: 43%;
  height: 1%;
  background-color: ${({ darkMode }) => (darkMode ? 'transparent' : '#fff')};
  background-image: ${({ darkMode }) => (darkMode ? `url(${adminBg})` : 'none')};
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  box-shadow: -4px 0 10px rgba(0, 0, 0, 0.2);
  z-index: ${({ showEditPanel }) => (showEditPanel ? 1 : 0)};
  padding: 9px;
  box-sizing: border-box;

  ${({ show }) => show && `transform: translateX(0);`}
`;

const SearchContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
  margin-top: 0px;
`;

const SearchInput = styled.input`
  padding: 8px;
  font-size: 14px;
  width: 250px;
  border: 1px solid #f2f2f2;
  border-radius: 5px;
`;

const BackButton = styled.button`
  position: fixed;
  left: 74px;
  bottom: 18px;
  z-index: 40;
  padding: 8px 14px;
  border: 1px solid #2e7d32;
  border-radius: 4px;
  background-color: #ffffff;
  color: #2e7d32;
  font-size: 14px;
  cursor: pointer;

  &:hover {
    background-color: #f2fff2;
  }
`;